import { IStoreState } from 'state/rootReducer';

export const getLatestDiagnoses = (state: IStoreState): Array<string> =>
  state.records.latestDiagnoses.latestDiagnoses;

export const getLatestDiagnosesError = (state: IStoreState): boolean =>
  state.records.latestDiagnoses.latestDiagnosesError;
